/* Northsheep — cookie settings link and consent log, for Shopify's own cookie
 * banner (Settings > Customer privacy > Cookie banner).
 *
 * Owner, 23 Sep 2026: no paid consent app on five stores if the free Shopify
 * banner can do it. Two things the free banner does not do, done here:
 *
 * 1. RE-OPEN FROM THE FOOTER. The GDPR wants withdrawing consent to be as
 *    easy as giving it (Art. 7(3)). Shopify documents privacyBanner
 *    .showPreferences() for exactly this; the footer's "Cookie settings" item
 *    stays hidden until that function exists, so a store without Shopify's
 *    banner never shows a link that does nothing.
 *
 * 2. A CONSENT LOG. The GDPR also wants the shop to be able to PROVE consent
 *    (Art. 7(1)). Shopify keeps the choice in the visitor's browser but offers
 *    the merchant no log, so every choice is posted to the address set in
 *    Theme settings (the owner's Google Apps Script on the consent sheet;
 *    n8n until 23 Sep 2026): a random id kept in this browser, the time, the
 *    four choices, the store, the country and the banner version. No name,
 *    no email, no IP address in the payload. Nothing is sent when the setting
 *    is empty.
 *
 * text/plain on purpose, as the return form does: a CORS "simple" request, so
 * the receiver needs no preflight handler. Sent WITHOUT cookies: sendBeacon
 * always carries the shopper's cookies for the receiving site, so a Chrome
 * shopper signed in to Google would have sent their Google cookies along with
 * the record, even after a Decline. keepalive lets the request finish when
 * the page is left right after the click.
 */
(function () {
  'use strict';

  var cfg = window.__nsConsent || {};

  function showLinks() {
    var items = document.querySelectorAll('[data-ns-cookie-item]');
    if (!items.length) return;
    var tries = 0;
    (function check() {
      var pb = window.privacyBanner;
      if (pb && typeof pb.showPreferences === 'function') {
        Array.prototype.forEach.call(items, function (li) {
          li.hidden = false;
        });
        return;
      }
      /* Shopify loads its banner script after the page; give it ten seconds. */
      if (++tries < 20) setTimeout(check, 500);
    })();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-ns-cookie-prefs]');
    if (!btn) return;
    e.preventDefault();
    var pb = window.privacyBanner;
    if (pb && typeof pb.showPreferences === 'function') pb.showPreferences();
  });

  function consentId() {
    try {
      var key = 'ns_consent_id';
      var v = window.localStorage.getItem(key);
      if (!v) {
        v = window.crypto && crypto.randomUUID
          ? crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2);
        window.localStorage.setItem(key, v);
      }
      return v;
    } catch (err) {
      return '';
    }
  }

  /* The visitor's real country (owner, 24 Sep 2026). Shopify.country is the
   * store's MARKET, not where the visitor is: on nordschaf.de most German
   * visitors were logged as "NL". Shopify's own storefront endpoint
   * /browsing_context_suggestions.json returns the country it detects for
   * this visitor. Asked once per visit in the background (sessionStorage),
   * so a click never waits for it; only the two-letter code is kept, never
   * an IP address. The market still goes along as "market" (stored only if
   * the sheet has a "market" column). */
  var geo = { value: '', pending: null };
  /* Only when the banner is actually there to be answered (audit B8, 2 Oct
   * 2026): a visitor who chose long ago never sees it, so their new visits
   * no longer ask. Shopify appends the banner to <body>; watched like
   * retext() below, without the subtree. */
  (function whenBanner() {
    if (!cfg.url) return;
    var go = function () {
      if (!document.getElementById('shopify-pc__banner') && !document.getElementById('shopify-pc__prefs')) return false;
      detectCountry();
      return true;
    };
    var start = function () {
      if (go()) return;
      var mo = new MutationObserver(function () {
        if (go()) mo.disconnect();
      });
      mo.observe(document.body, { childList: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  })();
  function detectCountry() {
    if (geo.value || geo.pending) return;
    try {
      var saved = window.sessionStorage.getItem('ns_geo_country');
      if (saved) { geo.value = saved; return; }
    } catch (err) {}
    if (!cfg.url || !window.fetch) return;
    geo.pending = fetch('/browsing_context_suggestions.json', { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (/^[A-Z]{2}$/.test(c || '')) {
          geo.value = c;
          try { window.sessionStorage.setItem('ns_geo_country', c); } catch (err) {}
        }
      })
      .catch(function () {});
  }

  document.addEventListener('visitorConsentCollected', function (e) {
    if (!cfg.url) return;
    var d = (e && e.detail) || {};
    // A choice made without the banner having shown (the footer's cookie link).
    if (!geo.value && !geo.pending) detectCountry();
    /* Lookup still running at the click: wait for it at most one second,
     * then log anyway (with the market as fallback). */
    if (!geo.value && geo.pending) {
      Promise.race([geo.pending, new Promise(function (r) { setTimeout(r, 1000); })])
        .then(function () { logChoice(d); });
      return;
    }
    logChoice(d);
  });

  function logChoice(d) {
    var market = (window.Shopify && window.Shopify.country) || '';
    var body = JSON.stringify({
      consent_id: consentId(),
      at: new Date().toISOString(),
      analytics: !!d.analyticsAllowed,
      marketing: !!d.marketingAllowed,
      preferences: !!d.preferencesAllowed,
      sale_of_data: !!d.saleOfDataAllowed,
      store: cfg.store || '',
      country: geo.value || market,
      market: market,
      language: document.documentElement.lang || '',
      page: window.location.pathname,
      banner_version: cfg.version || '',
      /* Which banner design the shopper saw (Theme settings > "Cookie banner
       * buttons"), and the choice in one word, so the sheet can compare the
       * share of accepts per design (owner, 23 Sep 2026). */
      banner_design: cfg.design || '',
      choice: d.analyticsAllowed && d.marketingAllowed && d.preferencesAllowed
        ? 'accept_all'
        : !d.analyticsAllowed && !d.marketingAllowed && !d.preferencesAllowed
          ? 'decline_all'
          : 'custom'
    });
    try {
      fetch(cfg.url, {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'omit',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' },
        body: body
      }).catch(function () {});
    } catch (err) {}
  }

  /* 3. THE BANNER'S OWN WORDS. Shopify's default text is long and stiff, and
   * "Manage preferences" wraps onto two lines as the middle of three equal
   * buttons (owner, 23 Sep 2026: "can you say Preferences instead"). The
   * title, the message and that label are replaced with the store's own,
   * from the locale files (northsheep.cookies.banner_*), so every store gets
   * them in its language. The link to the privacy policy is kept, with new
   * words; Accept and Decline keep Shopify's own translated labels. The
   * message still says what the cookies are for, which the consent has to
   * be informed about. If Shopify renames its markup, its own text simply
   * stays. */
  function decode(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s || '';
    return t.value;
  }

  function retext() {
    var banner = document.getElementById('shopify-pc__banner');
    var text = cfg.text;
    if (!banner || !cfg.retext || !text || banner.getAttribute('data-ns-retext') === '1') return;
    banner.setAttribute('data-ns-retext', '1');
    var title = document.getElementById('shopify-pc__banner__body-title');
    if (title && text.title) title.textContent = decode(text.title);
    var p = banner.querySelector('.shopify-pc__banner__body p');
    if (p && text.message) {
      var link = p.querySelector('a');
      p.textContent = decode(text.message) + ' ';
      if (link) {
        if (text.link) link.textContent = decode(text.link);
        p.appendChild(link);
      }
    }
    var prefs = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    if (prefs && text.prefs) {
      var label = prefs.querySelector('span') || prefs;
      label.textContent = decode(text.prefs);
    }
  }

  if (cfg.retext) {
    /* Shopify appends the banner to <body> after the page has loaded. A
     * childList observer on <body> alone (no subtree) sees exactly that and
     * nothing of the page's own churn; the change lands before the banner is
     * first painted. */
    var watchBody = function () {
      retext();
      new MutationObserver(retext).observe(document.body, { childList: true });
    };
    if (document.body) watchBody();
    else document.addEventListener('DOMContentLoaded', watchBody);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showLinks);
  else showLinks();
})();
